import React from "react";

import { Stack, SxProps } from "@mui/material";

import { StackProps } from "@rui/Stack";

interface ActionBarProps extends StackProps {
  children?: React.ReactNode;
  sx?: SxProps;
}

const ActionBar = ({ children, sx, ...props }: ActionBarProps) => {
  return (
    <Stack
      direction="row"
      sx={{
        height: "60px",
        backgroundColor: "#fff",
        width: "100%",
        padding: "10px 24px",
        position: "relative",
        zIndex: 10,
        borderBottom: (theme) =>
          `2px solid ${theme.palette.shades.neutral[100]}`,
        minHeight: "60px",
        ...sx,
      }}
      justifyContent="space-between"
      alignItems="center"
      {...props}
    >
      {children}
    </Stack>
  );
};

export default ActionBar;
